export default function GiftLinkExpired(): React.ReactElement {
  return (
    <p className="font-poppins text-base">
      {
        "Gifted stories are valid for only 14 days after they are shared. You can still read this and other premium stories by being a subscriber."
      }
    </p>
  );
}
